import {
  ALL_CREATABLE_REPORT_TYPES,
  REPORT_TYPE_BASE,
  REPORT_TYPE_SEQUENCE,
  ReportType,
} from '@navstation-portal/reporting/data-model/vessel-reports';

// A type with a row of its own uses it. A derived type with no row follows the
// row of its base type, because V1 decides the sequence from the class alone.
// Drifting has its own row, so it does not follow Anchor's.
export function getAllowedNextReportTypes(lastCompletedReportType: string | undefined): ReportType[] {
  if (!lastCompletedReportType) {
    return ALL_CREATABLE_REPORT_TYPES;
  }
  const type = lastCompletedReportType as ReportType;
  return REPORT_TYPE_SEQUENCE[type] ?? REPORT_TYPE_SEQUENCE[REPORT_TYPE_BASE[type]] ?? ALL_CREATABLE_REPORT_TYPES;
}
